import { Theme } from "@mui/material/styles";
import themeInstance from "@app/config/theme";

const styles = (theme: Theme = themeInstance) => ({
  headerCreate: {
    marginBottom: theme.spacing(3),
  },
});
export default styles;
